import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import { useState } from 'react';

const OffresEntreprisesPage = () => {
  const [formData, setFormData] = useState({
    entreprise: '',
    nom: '',
    email: '',
    telephone: '',
    secteur: '',
    besoins: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.entreprise || !formData.nom || !formData.email || !formData.telephone) {
      setSubmitMessage('Veuillez remplir tous les champs obligatoires');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formDataToSend = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d5nanev72m0gvhnvdvhg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend.toString(),
      });

      if (response.ok) {
        setSubmitMessage('Votre demande a été envoyée avec succès ! Notre équipe vous contactera sous peu.');
        setFormData({
          entreprise: '',
          nom: '',
          email: '',
          telephone: '',
          secteur: '',
          besoins: '',
          message: ''
        });
      } else {
        setSubmitMessage('Une erreur est survenue. Veuillez réessayer.');
      }
    } catch (error) {
      setSubmitMessage('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/28a9a491ec42aa19170e889045071864.jpg"
            alt="Offres Entreprises"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center">
          <span className="inline-block bg-[#E63946]/20 text-[#E63946] px-6 py-2 rounded-full text-sm font-semibold mb-6">
            OFFRES ENTREPRISES
          </span>
          <h1 className="text-white text-6xl lg:text-7xl font-black mb-6">
            Solutions Sur Mesure<br />
            <span className="text-[#E63946]">Pour Entreprises</span><br />
            et Institutions
          </h1>
          <p className="text-gray-200 text-xl max-w-3xl mx-auto leading-relaxed mb-12">
            Des offres personnalisées adaptées aux besoins spécifiques des professionnels, entreprises et institutions
          </p>
          <a
            href="tel:0779027536"
            className="inline-flex items-center gap-3 bg-[#E63946] text-white px-12 py-5 rounded-full font-bold text-lg shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer"
            style={{ boxShadow: '0 0 40px rgba(230, 57, 70, 0.5)' }}
          >
            <i className="ri-phone-line text-2xl"></i>
            Contactez-nous : 0779027536
          </a>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-gray-500 text-sm tracking-widest uppercase mb-4 block">POURQUOI NOUS CHOISIR</span>
            <h2 className="text-5xl font-bold text-black mb-4">
              Avantages Exclusifs
            </h2>
            <p className="text-gray-600 text-lg">
              Des services premium pour votre entreprise
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-vip-crown-line',
                title: 'Tarifs Préférentiels',
                description: 'Bénéficiez de tarifs avantageux sur vos commandes en volume et contrats long terme'
              },
              {
                icon: 'ri-customer-service-2-line',
                title: 'Gestionnaire Dédié',
                description: 'Un interlocuteur unique pour tous vos projets et un suivi personnalisé'
              },
              {
                icon: 'ri-time-line',
                title: 'Livraison Prioritaire',
                description: 'Délais de production réduits et livraison express garantie pour vos urgences'
              },
              {
                icon: 'ri-file-list-3-line',
                title: 'Facturation Simplifiée',
                description: 'Facturation mensuelle regroupée et conditions de paiement adaptées'
              },
              {
                icon: 'ri-box-3-line',
                title: 'Stockage Gratuit',
                description: 'Conservation de vos fichiers et stockage de vos supports imprimés'
              },
              {
                icon: 'ri-lightbulb-line',
                title: 'Conseil Stratégique',
                description: 'Accompagnement marketing et conseil en communication visuelle'
              }
            ].map((benefit, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#E63946] to-[#d32f3c] rounded-2xl flex items-center justify-center mb-6">
                  <i className={`${benefit.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="text-black text-xl font-bold mb-3">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 text-base leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-black mb-4">
              Nos Solutions Entreprise
            </h2>
            <p className="text-gray-600 text-lg">
              Un accompagnement complet pour votre communication
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {[
              {
                title: 'Branding Corporate',
                items: ['Identité visuelle complète', 'Charte graphique', 'Logo et déclinaisons', 'Manuel de marque'],
                image: 'https://readdy.ai/api/search-image?query=Corporate%20branding%20identity%20design%20business%20logo%20brand%20guidelines%20professional%20corporate%20identity%20materials%20elegant%20presentation%20modern%20design&width=700&height=500&seq=corp-brand-001&orientation=landscape'
              },
              {
                title: 'Communication Interne',
                items: ['Signalétique bureaux', 'Supports RH', 'Documentation interne', 'Cartes collaborateurs'],
                image: 'https://readdy.ai/api/search-image?query=Internal%20corporate%20communication%20office%20signage%20employee%20materials%20professional%20workplace%20branding%20clean%20modern%20office%20environment&width=700&height=500&seq=corp-internal-001&orientation=landscape'
              },
              {
                title: 'Marketing & Événements',
                items: ['Supports événementiels', 'PLV et merchandising', 'Stand et kakémonos', 'Goodies personnalisés'],
                image: 'https://readdy.ai/api/search-image?query=Corporate%20event%20marketing%20materials%20trade%20show%20booth%20promotional%20displays%20roll-up%20banners%20professional%20event%20setup%20business%20conference&width=700&height=500&seq=corp-event-001&orientation=landscape'
              },
              {
                title: 'Textile Professionnel',
                items: ['Uniformes entreprise', 'Vêtements de travail', 'Textile promotionnel', 'Accessoires brodés'],
                image: 'https://readdy.ai/api/search-image?query=Corporate%20uniforms%20professional%20workwear%20branded%20clothing%20company%20apparel%20team%20uniforms%20business%20attire%20clean%20presentation&width=700&height=500&seq=corp-textile-001&orientation=landscape'
              }
            ].map((service, index) => (
              <div
                key={index}
                className="bg-[#F8F9FA] rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 group"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <h3 className="absolute bottom-6 left-6 text-white text-3xl font-bold">
                    {service.title}
                  </h3>
                </div>
                <div className="p-8">
                  <ul className="space-y-3">
                    {service.items.map((item, idx) => (
                      <li key={idx} className="flex items-center gap-3">
                        <i className="ri-checkbox-circle-fill text-[#E63946] text-lg"></i>
                        <span className="text-gray-700 text-base">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-20 bg-gradient-to-br from-black via-[#2D3142] to-black">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-white text-5xl font-bold mb-4">
              Contactez Notre Équipe B2B
            </h2>
            <p className="text-gray-300 text-lg">
              Remplissez ce formulaire et un expert vous contactera sous 24h
            </p>
          </div>

          <div className="bg-white rounded-3xl p-8 md:p-12">
            <form onSubmit={handleSubmit} data-readdy-form id="entreprise-form">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div className="md:col-span-2">
                  <label htmlFor="entreprise" className="block text-gray-800 text-sm font-semibold mb-2">
                    Nom de l'entreprise <span className="text-[#E63946]">*</span>
                  </label>
                  <input
                    type="text"
                    id="entreprise"
                    name="entreprise"
                    value={formData.entreprise}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#E63946] focus:ring-2 focus:ring-[#E63946]/20 outline-none transition-all text-sm"
                    placeholder="Nom de votre entreprise"
                  />
                </div>

                <div>
                  <label htmlFor="nom" className="block text-gray-800 text-sm font-semibold mb-2">
                    Votre nom <span className="text-[#E63946]">*</span>
                  </label>
                  <input
                    type="text"
                    id="nom"
                    name="nom"
                    value={formData.nom}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#E63946] focus:ring-2 focus:ring-[#E63946]/20 outline-none transition-all text-sm"
                    placeholder="Nom et prénom"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-gray-800 text-sm font-semibold mb-2">
                    Email professionnel <span className="text-[#E63946]">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#E63946] focus:ring-2 focus:ring-[#E63946]/20 outline-none transition-all text-sm"
                    placeholder="contact@entreprise.com"
                  />
                </div>

                <div>
                  <label htmlFor="telephone" className="block text-gray-800 text-sm font-semibold mb-2">
                    Téléphone <span className="text-[#E63946]">*</span>
                  </label>
                  <input
                    type="tel"
                    id="telephone"
                    name="telephone"
                    value={formData.telephone}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#E63946] focus:ring-2 focus:ring-[#E63946]/20 outline-none transition-all text-sm"
                    placeholder="+243 xxx xxx xxx"
                  />
                </div>

                <div>
                  <label htmlFor="secteur" className="block text-gray-800 text-sm font-semibold mb-2">
                    Secteur d'activité
                  </label>
                  <select
                    id="secteur"
                    name="secteur"
                    value={formData.secteur}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#E63946] focus:ring-2 focus:ring-[#E63946]/20 outline-none transition-all text-sm cursor-pointer"
                  >
                    <option value="">Sélectionnez</option>
                    <option value="Commerce">Commerce</option>
                    <option value="Services">Services</option>
                    <option value="Industrie">Industrie</option>
                    <option value="Éducation">Éducation</option>
                    <option value="Santé">Santé</option>
                    <option value="ONG/Association">ONG/Association</option>
                    <option value="Administration">Administration publique</option>
                    <option value="Autre">Autre</option>
                  </select>
                </div>

                <div className="md:col-span-2">
                  <label className="block text-gray-800 text-sm font-semibold mb-2">
                    Besoins (sélectionnez)
                  </label>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                    {['Branding', 'Impression papier', 'Grand format', 'Textile', 'Événementiel', 'Marketing digital'].map((item) => (
                      <label key={item} className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="checkbox"
                          name="besoins"
                          value={item}
                          onChange={(e) => {
                            const value = e.target.value;
                            const currentBesoins = formData.besoins.split(', ').filter(b => b);
                            if (e.target.checked) {
                              setFormData({
                                ...formData,
                                besoins: [...currentBesoins, value].join(', ')
                              });
                            } else {
                              setFormData({
                                ...formData,
                                besoins: currentBesoins.filter(b => b !== value).join(', ')
                              });
                            }
                          }}
                          className="w-4 h-4 text-[#E63946] border-gray-300 rounded focus:ring-[#E63946] cursor-pointer"
                        />
                        <span className="text-gray-700 text-sm">{item}</span>
                      </label>
                    ))}
                  </div>
                </div>

                <div className="md:col-span-2">
                  <label htmlFor="message" className="block text-gray-800 text-sm font-semibold mb-2">
                    Décrivez votre projet
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={5}
                    maxLength={500}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#E63946] focus:ring-2 focus:ring-[#E63946]/20 outline-none transition-all resize-none text-sm"
                    placeholder="Parlez-nous de vos besoins et objectifs..."
                  ></textarea>
                  <p className="text-gray-500 text-xs mt-1">Maximum 500 caractères</p>
                </div>
              </div>

              <div className="text-center">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-[#E63946] text-white px-12 py-4 rounded-full font-bold text-base shadow-2xl hover:bg-[#d32f3c] transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
                >
                  {isSubmitting ? (
                    <>
                      <i className="ri-loader-4-line animate-spin"></i>
                      Envoi en cours...
                    </>
                  ) : (
                    <>
                      <i className="ri-send-plane-fill"></i>
                      Envoyer la demande
                    </>
                  )}
                </button>
              </div>

              {submitMessage && (
                <div className={`mt-6 p-4 rounded-lg text-center ${
                  submitMessage.includes('succès') 
                    ? 'bg-green-100 text-green-800' 
                    : 'bg-red-100 text-red-800'
                }`}>
                  <p className="text-sm font-medium">{submitMessage}</p>
                </div>
              )}
            </form>
          </div>
        </div>
      </section>

      {/* CTA Direct */}
      <section className="py-20 bg-[#F8F9FA]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-black text-4xl font-bold mb-6">
            Besoin d'échanger rapidement ?
          </h2>
          <p className="text-gray-700 text-lg mb-8">
            Notre équipe est disponible pour répondre à toutes vos questions
          </p>
          <div className="flex flex-wrap gap-5 justify-center">
            <a
              href="tel:0779027536"
              className="bg-black text-white px-10 py-4 rounded-full font-bold text-base hover:bg-gray-800 transition-all duration-300 flex items-center gap-3 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              Appelez-nous : 0779027536
            </a>
            <Link
              to="/commande-devis"
              className="border-2 border-black text-black px-10 py-4 rounded-full font-bold text-base hover:bg-black hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Devis Standard
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default OffresEntreprisesPage;